const baseUrls = {
  medicalServicesGatewayUsersApiBaseUrl: `${process.env.REACT_APP_MED_SERVICES_GATEWAY_BASE_URL}/users-api/api`,
  medicalServicesGatewayApiBaseUrl: `${process.env.REACT_APP_MED_SERVICES_GATEWAY_BASE_URL}/medicalservices-api/api`,
  medicalServicesGatewayDoctorApiBaseUrl: `${process.env.REACT_APP_MED_SERVICES_GATEWAY_BASE_URL}/doctor-api/api`,
};
const urls = {
  masterServicesUrls: {
    getApiAuthToken: `${baseUrls.medicalServicesGatewayUsersApiBaseUrl}/logins/externallogin`,
    getMasterServices: `${baseUrls.medicalServicesGatewayApiBaseUrl}/masterservices`,
    addMasterService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/masterservices`,
    editMasterService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/masterservices`,
    deleteMasterService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/masterservices`,
    getCategories: `${baseUrls.medicalServicesGatewayApiBaseUrl}/categories`,
  },
  servicesUrl: {
    getSpecialities: `${baseUrls.medicalServicesGatewayDoctorApiBaseUrl}/Specialities/GetMainSpecialities`,
    getServices: `${baseUrls.medicalServicesGatewayApiBaseUrl}/services`,
    addService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/services`,
    editService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/services`,
    deleteService: `${baseUrls.medicalServicesGatewayApiBaseUrl}/services`,
  },
  files: {
    contentUploader: `${process.env.REACT_APP_MED_SERVICES_GATEWAY_BASE_URL}/contentuploader-api/api/contentuploader`,
  },
};

export default urls;
